module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-20-8144539e3893a44bdc6e68dd0349a661.jpg";